/* tslint:disable */
/* eslint-disable */
/**
 * View API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ViewEnumerationActionSetFromJSON, ViewEnumerationActionSetToJSON } from './ViewEnumerationActionSet';
import { ViewFromJSON, ViewToJSON } from './View';

/**
 * 
 * @export
 * @interface ViewEnumerationResult
 */

/**
 * Check if a given object implements the ViewEnumerationResult interface.
 */
export function instanceOfViewEnumerationResult(value) {
  return true;
}
export function ViewEnumerationResultFromJSON(json) {
  return ViewEnumerationResultFromJSONTyped(json, false);
}
export function ViewEnumerationResultFromJSONTyped(json, ignoreDiscriminator) {
  if (json == null) {
    return json;
  }
  return {
    'items': json['items'] == null ? undefined : json['items'].map(ViewFromJSON),
    'actions': json['actions'] == null ? undefined : ViewEnumerationActionSetFromJSON(json['actions'])
  };
}
export function ViewEnumerationResultToJSON(value) {
  if (value == null) {
    return value;
  }
  return {
    'items': value['items'] == null ? undefined : value['items'].map(ViewToJSON),
    'actions': ViewEnumerationActionSetToJSON(value['actions'])
  };
}